<template>
  <div id="not-found">
    <div class="sectionheader">
      <h1>404</h1>
      <h5>
        {{ generalLabel.NOT_PUBLISH_PAGE_MESSAGE }}
      </h5>
    </div>
  </div>
</template>

<script>
import generalLabel from "../properties/general_page/generalpage-labels.json" ;

export default {
  name: "not-found",
  created() {
    document.title = "Page Not Found";
    alert(generalLabel.NOT_PUBLISH_PAGE_MESSAGE);
  },
  data() {
    return {
      generalLabel: generalLabel
    }
  }
};
</script>
<style scoped>
.sectionheader {
  text-align: center;
}
</style>
